/* eslint-disable id-length */
interface FilterUniqueByOptions {
    exact?: boolean;
}

/**
 * Filters values in an array to be unique
 *
 * @param mappingFunc - T
 * @param options - The options
 * @param options.exact - Should we use === or ==
 * @returns - The filter function
 */
export function filterUniqueBy<T, V>(
    mappingFunc: (value: T) => V,
    options?: FilterUniqueByOptions,
): (value: T, index: number, arr: T[]) => boolean {
    const { exact = true } = options ?? {};
    // eslint-disable-next-line eqeqeq
    const comparitorFunc = exact ? (a: any, b: any) => a === b : (a: any, b: any) => a == b;
    return (value, index, arr) => {
        const mappedValue = mappingFunc(value);
        return arr.findIndex(val => comparitorFunc(mappingFunc(val), mappedValue)) === index;
    };
}
